import { Component, TemplateRef, ViewChild } from '@angular/core';
import { TableComponent } from '../../../components/table/table.component';
import { Column, Paging } from '../../../core/types/helper.model';
import { PageHeaderService } from '../../../core/services/page-header.service';
import { EMPTY, of, tap } from 'rxjs';
import { PaymentService } from '../payment-services/payment.service';
import { PaymentMethod, PaymentStatus, PaymentType } from '../payment-const/payment-enums';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { CommonModule, NgIf } from '@angular/common';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../core/auth/services/auth.service';

@Component({
  selector: 'patient-payment-history',
  imports: [
    ButtonModule,
    TableComponent,
    DialogModule,
    TableModule,
    TooltipModule,
    CommonModule,
    InputNumberModule,
    FormsModule,
    NgIf,
  ],
  templateUrl: './payment-history.component.html',
  styleUrl: './payment-history.component.css',
})
export class PaymentHistoryComponent {
  @ViewChild('paymentMethodTemplate', { static: true })
  paymentMethodTemplate!: TemplateRef<any>;

  @ViewChild(TableComponent) appTable!: TableComponent;

  @ViewChild('statusTemplate', { static: true })
  statusTemplate!: TemplateRef<any>;

  @ViewChild('PaymentTemplate', { static: true })
  PaymentTemplate!: TemplateRef<any>;

  column: Column[] = [];
  paymentData: any[] = [];
  patientId!: string;

  paging: Paging = {
    pageSize: 10,
    pageNumber: 1,
  };

  constructor(
    private _pageHeaderService: PageHeaderService,
    private _paymentServices: PaymentService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.authService.getUserProfile().subscribe((res) => {
      if (res?.PatientId) {
        this.patientId = res.PatientId;

        console.log(this.patientId, 'Patient ID loaded');

        this.appTable?.reload();
      }
    });

    this.column = [
      {
        field: 'patient_name',
        header: 'Patient Name',
        filterable: true,
        sortable: true,
      },
      {
        field: 'transaction_date',
        header: 'Transaction Date',
        filterable: true,
        filterType: 'date',
        sortable: true,
        cellRenderer: (data: any) => {
          const d = new Date(data.transaction_date);
          return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        },
      },
      {
        field: 'transaction_amount',
        header: 'Amount (₹)',
        filterable: true,
        filterType: 'numeric',
        sortable: true,
        cellRenderer: (data: any) => {
          return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
          }).format(data.transaction_amount);
        },
      },
      {
        field: 'payment_status',
        header: 'Status',
        filterable: false,
        filterType: 'numeric',
        sortable: false,
        cellTemplate: this.statusTemplate,
      },
      {
        field: 'transaction_id',
        header: 'Transaction ID',
        filterable: true,
        sortable: false,
      },

      {
        field: ' gateway_transaction_id',
        header: 'PayU Transaction ID',
        filterable: true,
        sortable: false,
      },
      {
        field: 'payment_method',
        header: 'Payment Method',
        filterType: 'numeric',
        filterable: false,
        sortable: false,
        cellTemplate: this.paymentMethodTemplate,
      },
      {
        field: 'charge_type',
        header: 'Charge Type',
        filterType: 'numeric',
        filterable: false,
        sortable: false,
        cellTemplate: this.PaymentTemplate,
      },
      {
        field: 'actions',
        header: 'Actions',
        filterable: false,
        sortable: false,
      },
    ];
  }

  ngAfterViewInit() {
    if (this.patientId) {
      this.appTable.reload();
    }
  }

  loadData(data: Paging, componentInstance?: PaymentHistoryComponent) {
    if (!componentInstance?.patientId) {
      console.log('❌ Prevented API call - patientId not ready');
      return of({
        data: [],
        totalRecords: 0,
      });
    }

    if (!componentInstance) {
      return EMPTY;
    }
    if (data.filter) {
      data.filter = `${data.filter} and patient_id eq ${componentInstance.patientId}`;
    } else {
      data.filter = `patient_id eq ${componentInstance.patientId}`;
    }
    return componentInstance?._paymentServices.getAllPayment(data).pipe(tap((res: any) => {}));
  }

  // enums transformations

  getPaymentType(type: number): string {
    return PaymentType[type] || 'Unknown';
  }

  getPaymentStatus(status: number): string {
    return PaymentStatus[status] || 'Unknown';
  }

  getPaymentMethod(method: number): string {
    return PaymentMethod[method] || 'Unknown';
  }

  getStatusClass(status: number | string): string {
    const value = Number(status);

    switch (value) {
      case 301:
        return 'bg-green-500 text-white rounded-2xl px-3 py-1';
      case 306:
        return 'bg-yellow-500 text-white rounded-2xl px-3 py-1';
      case 311:
        return 'bg-red-500 text-white rounded-2xl px-3 py-1';
      case 316:
        return 'bg-blue-500 text-white rounded-2xl px-3 py-1';
      case 321:
        return 'bg-gray-500 text-white rounded-2xl px-3 py-1';
      case 322:
        return 'bg-purple-500 text-white rounded-2xl px-3 py-1';
      default:
        return 'bg-gray-300 text-black rounded-2xl px-3 py-1';
    }
  }

  resetFilters() {
    if (this.appTable) {
      this.appTable.resetFilters();
    }
  }
}
